/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Checkback2Inputs */

const id_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali lagi setelah tanggal rilis untuk meninggalkan ulasan!`)
};

const ms_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali selepas tarikh keluaran untuk meninggalkan ulasan!`)
};

const da_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kig tilbage efter udgivelsesdatoen for at skrive en anmeldelse!`)
};

const de_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schauen Sie nach dem Veröffentlichungsdatum wieder vorbei, um eine Bewertung zu hinterlassen!`)
};

const en_us2_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check back after the release date to leave a review!`)
};

const es_es2_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Vuelve después de la fecha de lanzamiento para dejar una reseña!`)
};

const es_mx2_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Vuelve después de la fecha de lanzamiento para dejar una reseña!`)
};

const fil_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bumalik pagkatapos ng release date para mag-iwan ng review!`)
};

const fr_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenez après la date de sortie pour laisser un avis !`)
};

const it_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna dopo la data di uscita per lasciare una recensione!`)
};

const hu_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nézz vissza a megjelenés után, hogy értékelést írhass!`)
};

const nl_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom terug na de releasedatum om een review achter te laten!`)
};

const no_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom tilbake etter utgivelsesdatoen for å legge igjen en omtale!`)
};

const pl_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wróć po dacie premiery, aby napisać recenzję!`)
};

const pt_br2_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte após a data de lançamento para deixar um comentário!`)
};

const pt_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte após a data de lançamento para deixar uma avaliação!`)
};

const ro_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reveniți după data lansării pentru a lăsa o recenzie!`)
};

const fi_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaa julkaisupäivän jälkeen jättääksesi arvostelun!`)
};

const sv_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom tillbaka efter releasedatumet för att lämna en recension!`)
};

const vi_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại sau ngày phát hành để để lại đánh giá!`)
};

const tr_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum bırakmak için çıkış tarihinden sonra tekrar gelin!`)
};

const cs_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vraťte se po datu vydání a napište recenzi!`)
};

const bg_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Върнете се след датата на издаване, за да оставите ревю!`)
};

const ru_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загляните после даты выхода, чтобы написать обзор!`)
};

const uk_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повертайтеся після дати виходу, щоб залишити відгук!`)
};

const ar_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عد بعد تاريخ الإصدار لترك مراجعة!`)
};

const hi_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा लिखने के लिए रिलीज़ तिथि के बाद वापस आएँ!`)
};

const th_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับมาหลังวันวางจำหน่ายเพื่อเขียนรีวิว!`)
};

const ja_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース日以降に戻ってきてレビューを書いてください！`)
};

const zh_cn2_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请在产品发布后再回来发表评论！`)
};

const zh_hant1_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請在產品發布後再回來發表評論！`)
};

const ko_offerdetail_reviews_checkback2 = /** @type {(inputs: Offerdetail_Reviews_Checkback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시일 이후에 다시 방문하여 리뷰를 남겨주세요!`)
};

/**
* | output |
* | --- |
* | "Check back after the release date to leave a review!" |
*
* @param {Offerdetail_Reviews_Checkback2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_checkback2 = /** @type {((inputs?: Offerdetail_Reviews_Checkback2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Checkback2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_checkback2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_checkback2(inputs)
	if (locale === "da") return da_offerdetail_reviews_checkback2(inputs)
	if (locale === "de") return de_offerdetail_reviews_checkback2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_checkback2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_checkback2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_checkback2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_checkback2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_checkback2(inputs)
	if (locale === "it") return it_offerdetail_reviews_checkback2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_checkback2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_checkback2(inputs)
	if (locale === "no") return no_offerdetail_reviews_checkback2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_checkback2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_checkback2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_checkback2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_checkback2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_checkback2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_checkback2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_checkback2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_checkback2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_checkback2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_checkback2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_checkback2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_checkback2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_checkback2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_checkback2(inputs)
	if (locale === "th") return th_offerdetail_reviews_checkback2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_checkback2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_checkback2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_checkback2(inputs)
	return ko_offerdetail_reviews_checkback2(inputs)
});
export { offerdetail_reviews_checkback2 as "offerDetail.reviews.checkBack" }